package com.vizio.pay.api

import com.vizio.redwolf.consent.api.ConsentResult
import com.vizio.redwolf.consent.api.ConsentV2FusedApi
import com.vizio.redwolf.consent.model.ConsentAction
import com.vizio.redwolf.consent.model.ConsentGroupAction
import com.vizio.redwolf.consent.model.SaveUserConsentV2ProxyRequestInfo
import com.vizio.redwolf.consent.model.UserConsentV2DataRequestInfo
import com.vizio.redwolf.consent.model.UserConsentV2ProxyStatusRequestInfo
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.ConsentV2FusedEnvironment
import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import kotlin.js.Promise

@JsExport
class ConsentV2FusedJsApi(consentV2Env: ConsentV2FusedEnvironment, jsClientConfig: JsClientConfig? = null) {
    private val consentV2Api = ConsentV2FusedApi(consentEnv = consentV2Env,
                                                 appConfig = AppConfig(""),
                                                 clientConfig = jsClientConfig.toClientConfig(WebApiUseCase.SDK_HEADERS)
    )

    @JsName("getConsentData")
    fun getConsentData(requestJSInfo: dynamic, traceId: String? = null): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleConsentJsException) {
            val requestInfo = UserConsentV2DataRequestInfo(
                consentIds = (requestJSInfo.consentIds as Array<String>).toList(),
                consentGroupIds = (requestJSInfo.consentGroupIds as Array<String>).toList(),
                acceptLanguage = requestJSInfo.acceptLanguage as String,
                consentMessageFormat = requestJSInfo.consentMessageFormat as String,
                expand = requestJSInfo.expand as Boolean
            )
            consentV2Api.requestConsentData(requestInfo, traceId = traceId)
        }
    }

    @JsName("saveUserConsent")
    fun saveUserConsent(requestJSInfo: dynamic, traceId: String? = null): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleConsentJsException) {
            val requestInfo = SaveUserConsentV2ProxyRequestInfo(
                userId = requestJSInfo.userId as String,
                userIdType = requestJSInfo.userIdType as String,
                consentIdsActions = ConsentAction(
                    acceptList = (requestJSInfo.consentIdsActions.acceptList as Array<String>).toList(),
                    rejectList = (requestJSInfo.consentIdsActions.rejectList as Array<String>).toList()
                ),
                consentGroupIdsActions = ConsentGroupAction(
                    acceptList = (requestJSInfo.consentGroupIdsActions.acceptList as Array<String>).toList(),
                    rejectList = (requestJSInfo.consentGroupIdsActions.rejectList as Array<String>).toList()
                ),
                consentToken = requestJSInfo.consentToken as String,
                accessToken = requestJSInfo.accessToken as String
            )
            consentV2Api.saveUserConsent(requestInfo, traceId = traceId)
        }
    }

    @JsName("requestUserConsentStatus")
    fun requestUserConsentStatus(requestJSInfo: dynamic, traceId: String? = null): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleConsentJsException) {
            val requestInfo = UserConsentV2ProxyStatusRequestInfo(
                userId = requestJSInfo.userId as String,
                userIdType = requestJSInfo.userIdType as String,
                consentIds = (requestJSInfo.consentIds as Array<String>).toList(),
                consentGroupIds = (requestJSInfo.consentGroupIds as Array<String>).toList(),
                accessToken = requestJSInfo.accessToken as String
            )
            consentV2Api.requestUserConsentStatus(requestInfo, traceId = traceId)
        }
    }

    private fun <T: Any> handleConsentJsException(ex: Exception, data: JsExceptionInfo<T>? = null): ConsentResult.Error {
        return ConsentResult.Error(ResponseHeaders.Invalid, Exception(jsRequestExceptionError))
    }

}